import React, { ReactElement } from 'react'
import ReactTooltip from 'react-tooltip'

import { cloudIco, heatIco, fafIco, cloudToGoIco, checkBox, tariffDetails } from '../../../assets'
import TariffCondition from '../TariffCondition'

const Component = (props: {
  productType: string;
  downPayment: string;
  bullet1: string;
  info1?: string;
  bullet2: string;
  info2?: string
  bullet3?: string;
  info3?: string;
  productReduceCharges?: boolean;
  conditions: {
    [key: string]: string;
  }
}): ReactElement => {
  const {
    productType,
    downPayment,
    bullet1,
    info1,
    bullet2,
    info2,
    bullet3,
    info3,
    productReduceCharges
  } = props

  let productTypeImage

  switch (productType) {
    case 'Wärme':
      productTypeImage = heatIco
      break
    case 'Cloud':
      productTypeImage = cloudIco
      break
    case 'Cloud to go':
      productTypeImage = cloudToGoIco
      break
    case 'Family & Friends 1':
    case 'Family & Friends 2':
      productTypeImage = fafIco
      break
    default:
      productTypeImage = cloudIco
      break
  }

  const conditionInfo = Object.entries(props.conditions)

  return (
    <div className="flex pb-10 flex-wrap">
      {/** left column */}
      <div className="w-full sm:w-full md:w-1/2 md:pl-16 md:pr-8">
        <div className="flex items-start align-items-center mb-4">
          <img
            src={`/themes/custom/granite/react-form-app/build${productTypeImage}`}
            className="img img-fluid h-25 w-25 mr-6"
            alt="product symbol"
          />
          <h3 className="h3 text-align-left self-center">SENEC.{productType}</h3>
        </div>
        {conditionInfo.map((pair, index) => (
          <div key={index} className="flex justify-between mb-2">
            <div>{pair[0]}</div>
            <div className="text-align-right">{pair[1]}</div>
          </div>
        ))}
      </div>
      {/** right column */}
      <div className="w-full sm:w-full md:w-1/2 md:pl-8 md:pr-16">
        <div className="flex pl-4 items-center">
          <div className="text-right">
            <h1 className="h1" style={{ color: '#000099' }}>{downPayment} €</h1>
            <h5 className="h5">monatlicher Abschlag</h5>
          </div>
        </div>
        <div className="flex flex-nowrap items-center">
          <img
            src={`/themes/custom/granite/react-form-app/build${checkBox}`}
            className="img img-fluid h-10 w-10 object-cover"
            alt="checkbox"
          />
          <div className="flex items-center">
            <p className="h5 p-2 justify-center">{bullet1}</p>
            {info1 && (
              <div className="ml-2">
                <div className="form-group__info-icon">
                  <i
                    className="info-icon"
                    data-tip
                    data-for="bullet1"
                    data-place="bottom"
                    data-event="click focus"
                  />
                </div>
                <ReactTooltip
                  id={'bullet1'}
                  effect="solid"
                  globalEventOff="click"
                >
                  <div className="form-group__info absolute active">
                    {info1}
                  </div>
                </ReactTooltip>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-nowrap items-center">
          <img
            src={`/themes/custom/granite/react-form-app/build${checkBox}`}
            className="img img-fluid h-10 w-10 object-cover"
            alt="checkbox"
          />
          <div className="flex items-center">
            <p className="h5 p-2 justify-center">{bullet2}</p>
            {info2 && (
              <div className="ml-2">
                <div className="form-group__info-icon">
                  <i
                    className="info-icon"
                    data-tip
                    data-for="bullet2"
                    data-place="bottom"
                    data-event="click focus"
                  />
                </div>
                <ReactTooltip
                  id={'bullet2'}
                  effect="solid"
                  globalEventOff="click"
                >
                  <div className="form-group__info active">
                    {info2}
                  </div>
                </ReactTooltip>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-nowrap items-center">
          <img
            src={`/themes/custom/granite/react-form-app/build${checkBox}`}
            className="img img-fluid h-10 w-10 object-cover"
            alt="checkbox"
          />
          <div className="flex items-center relative">
            <p className="h5 p-2 justify-center">{bullet3}</p>
            {info3 && (
              <div>
                <div className="form-group__info-icon">
                  <i
                    className="info-icon"
                    data-tip
                    data-for="bullet1"
                    data-place="bottom"
                    data-event="click focus"
                  />
                </div>
                <ReactTooltip
                  id={'bullet3'}
                  effect="solid"
                  globalEventOff="click"
                >
                  <div className="form-group__info absolute active">
                    {info3}
                  </div>
                </ReactTooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center w-full">
        <div className="md:w-4/5 flex-nowrap flex justify-center items-center bg-light-gray mx-auto"
             style={{ alignItems: 'center' }}>
          <qz-accordion
            className="accordion my-5 w-full mt-4 bg-color-grey"
            id="accordion--tarifdetails">
            <h3 slot="invoker">
              <button className="text-left" type="button">
                <img
                  src={`/themes/custom/granite/react-form-app/build${tariffDetails}`}
                  className="img img-fluid"
                  alt="TarifDetails"
                />
                <h5 className="h5">Tarifdetails</h5>
                <qz-icon name="plus" opener aria-hidden="true"></qz-icon>
                <qz-icon name="minus" closer aria-hidden="true"></qz-icon>
              </button>
            </h3>
            <div slot="content" className="pt-4">
              <TariffCondition
                productType={productType}
                productReduceCharges={productReduceCharges}
              >
              </TariffCondition>
            </div>
          </qz-accordion>
        </div>
      </div>
    </div>
  )
}

export default Component
